import React from "react"
import Helmet from "react-helmet"
import { withPrefix, Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

import About from "../components/aboutus_company"

const IndexPage = () => (
    <Layout>
      <div className="index-background">
      <section className="hero is-fullheight-with-navbar info-mobile-friendly">
        <div className="hero-body">
          <div className="container index-page">
            <div className="section index-page-padding-remove">
              <h1 className="title" id="index-title">
                Strendingur ehf.
              </h1>
              <h2 className="subtitle" id="index-subtitle">
                verkfræðiþjónusta síðan 1995
              </h2>
            </div>
            </div>
        </div>
      </section>
      </div>
      <About />
    </Layout>
)

export default IndexPage
